import { render, staticRenderFns } from "./ResumenVejezAnticipada.vue?vue&type=template&id=54c06eb4&scoped=true"
import script from "./ResumenVejezAnticipada.vue?vue&type=script&lang=ts"
export * from "./ResumenVejezAnticipada.vue?vue&type=script&lang=ts"
import style0 from "./ResumenVejezAnticipada.vue?vue&type=style&index=0&id=54c06eb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c06eb4",
  null
  
)

export default component.exports